/** Leadership team — aligned with Velocity Fund platform deck (Oct 2025) */

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  imageClassName?: string;
  className?: string;
  /** When false, skip outer ring — photo already includes its own circular frame */
  showFrame?: boolean;
  /** Photo is already a full circle with border — render without extra clip/ring */
  intrinsic?: boolean;
};

export const teamIntro = {
  eyebrow: "Leadership",
  title: "Our team",
  description:
    "Our founding team has successfully operated, scaled, and exited businesses—combining institutional discipline with entrepreneurial execution across private credit and wealth management.",
} as const;

export const leadershipTeam: TeamMember[] = [
  {
    name: "Charan Roy",
    role: "Co-Founder · Debt & Structured Finance",
    bio: "Over 6 years in structured finance and corporate credit, with an extensive track record of buying, scaling, and exiting businesses. Has led transactions exceeding USD 50 million across real estate, NBFCs, and manufacturing. Before founding Godman Capital, he led debt strategy at Sprout Capital and began his career at Synergy Finserv.",
    photo: "/team-charan.png",
  },
  {
    name: "Keshav Jain",
    role: "Vice President – Portfolio",
    bio: "6+ years in global financial services with deep expertise in credit structuring, financial analytics, and performance modeling. Former J.P. Morgan Risk Division. Master's in Finance, University of Alberta.",
    photo: "/team-keshav.png",
  },
  {
    name: "Suman Agarwal",
    role: "Principal – Asset Management",
    bio: "Suman is a SEBI-registered RM with 5+ years in wealth and portfolio management. Ex-Motilal Oswal, CFA + CPA, NMIMS Mumbai. He oversees LP communications, product structuring, and AUM growth.",
    photo: "/team-suman.png",
    intrinsic: true,
  },
  {
    name: "Priya Agarwal",
    role: "Lead – Wealth Management",
    bio: "Leads product innovation and investor engagement for Godman's private clients. Background in product strategy and capital markets, with a focus on HNI and family office relationships.",
    photo: "/team-priya.png",
  },
  {
    name: "Rahul Mehta",
    role: "Strategic Advisor",
    bio: "Decades of experience in asset and wealth management, including as Head of Investments at Citibank. Former leadership roles at Anand Rathi, Motilal Oswal, and Edelweiss Group.",
    photo: "/team-rahul.png",
  },
];
